/**
 * Single source of truth for company / brand metadata.
 *
 * Update values here and they propagate to:
 *  - SEO + OpenGraph tags in `src/routes/__root.tsx`
 *  - Legal layout/footer chrome
 *  - Transactional email template defaults
 *  - Server-side notification senders (`src/lib/notify.server.ts`)
 *
 * The PWA manifest (`public/manifest.webmanifest`) is static JSON and must
 * be edited there directly — keep it in sync with `COMPANY_NAME`.
 */
export const COMPANY_NAME = "The Hospitality Reserve";
export const COMPANY_SHORT_NAME = "The Hospitality Reserve";
/**
 * Canonical marketing tagline. Every landing hero, CTA subheading, meta
 * description, OG tag, and MCP/agent description MUST pull from these
 * constants — never hardcode the string, so we can update wording in one
 * place without drift across routes, emails, or SEO metadata.
 */
export const MARKETING_TAGLINE = "The Hospitality Reserve";
export const MARKETING_SUBHEAD =
  "A trusted network for venues to book reliable bartenders and for bartenders to pick up shifts on their own terms. Vetted people, direct bookings, and prompt payment — set up in under a minute.";
export const COMPANY_TAGLINE = MARKETING_TAGLINE;
export const COMPANY_DOMAIN = "thehospitalityreserve.com";
export const COMPANY_URL = `https://${COMPANY_DOMAIN}`;
export const SUPPORT_EMAIL = "Admin@Thehospitalityreserve.com";
export const COMPANY_DESCRIPTION = `${MARKETING_TAGLINE}. Bartenders and venues work directly, on their own terms.`;
export const COMPANY_OG_DESCRIPTION = MARKETING_TAGLINE;
export const COMPANY_LOCATION = "";

export const BRAND = {
  name: COMPANY_NAME,
  shortName: COMPANY_SHORT_NAME,
  tagline: MARKETING_TAGLINE,
  subhead: MARKETING_SUBHEAD,
  domain: COMPANY_DOMAIN,
  url: COMPANY_URL,
  supportEmail: SUPPORT_EMAIL,
  description: COMPANY_DESCRIPTION,
  ogDescription: COMPANY_OG_DESCRIPTION,
  location: COMPANY_LOCATION,
} as const;
